import * as React from "react";
import type { SVGProps } from "react";
const CarDealership = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4355_7158)">
      <path
        fill="currentColor"
        d="M6.2229 6.4866h1.9144V9.974h-4.094l1.1043-2.7572a1.156 1.156 0 0 1 1.0753-.7302M9.881 9.974V6.4866h2.9498c.3524 0 .6866.1598.9082.4359l2.4412 3.0515zm9.3071.0363-3.6327-4.5409c-.6612-.8283-1.6638-1.3078-2.7246-1.3078h-6.608c-1.4276 0-2.71.8682-3.2367 2.1906L1.475 10.1338C.6103 10.4753 0 11.3145 0 12.2989v4.0687c0 .643.5195 1.1625 1.1625 1.1625h1.2097c.276 1.6493 1.711 2.9062 3.4402 2.9062s3.164-1.2569 3.4402-2.9062h4.748c.2761 1.6493 1.711 2.9062 3.4402 2.9062s3.1641-1.2569 3.4402-2.9062h1.2097c.643 0 1.1624-.5195 1.1624-1.1625v-1.7437c0-2.3685-1.7727-4.323-4.0614-4.6136zm-3.3966 6.3573a1.744 1.744 0 0 1 3.2305-.182 1.744 1.744 0 0 1 .0571 1.3445 1.7437 1.7437 0 1 1-3.2876-1.1625m-9.9791-1.1625a1.7438 1.7438 0 0 1 0 3.4875 1.7436 1.7436 0 1 1 0-3.4875"
      />
    </g>
    <defs>
      <clipPath id="clip0_4355_7158">
        <path fill="transparent" d="M0 3h23.2495v18.5996H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default CarDealership;
